module.exports = __webpack_public_path__ + "static/img/login_model_left.24f327eb.png";